import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api'),
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vendly_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vendly_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ────────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  update: (data) => api.put('/auth/me', data),
};

// ─── Products ────────────────────────────────────────────────
export const productsAPI = {
  list: (params) => api.get('/products', { params }),
  get: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  categories: () => api.get('/products/categories'),
};

// ─── Orders ──────────────────────────────────────────────────
export const ordersAPI = {
  create:        (data) => api.post('/orders', data),
  list:          ()     => api.get('/orders'),
  get:           (id)   => api.get(`/orders/${id}`),
  claimPaid:     (id)   => api.post(`/orders/${id}/paid`),
  setPaystackRef:(id, reference) => api.put(`/orders/${id}/paystack-ref`, { reference }),
};

export const addressesAPI = {
  list:       ()     => api.get('/addresses'),
  save:       (data) => api.post('/addresses', data),
  delete:     (id)   => api.delete(`/addresses/${id}`),
  setDefault: (id)   => api.put(`/addresses/${id}/default`),
};

// ─── Uploads ─────────────────────────────────────────────────
export const uploadsAPI = {
  image: (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/uploads/image', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteImage: (publicId) => api.delete(`/uploads/image/${publicId}`),
};

export default api;

export const notificationsAPI = {
  list:       ()    => api.get('/notifications'),
  readAll:    ()    => api.put('/notifications/read-all'),
  read:       (id)  => api.put(`/notifications/${id}/read`),
};

export const reviewsAPI = {
  list:   (productId)       => api.get(`/reviews/product/${productId}`),
  add:    (productId, data) => api.post(`/reviews/product/${productId}`, data),
  delete: (reviewId)        => api.delete(`/reviews/${reviewId}`),
};
